import { Button } from "PFComponents/button/button";
import { Stack } from "PFComponents/containers/flex";
import { Typography } from "PFComponents/typography/typography";
import { useTranslation } from "react-i18next";

import css from "./propilot_system_error_bubble.module.scss";

type ProPilotSystemErrorBubbleProps = {
  text: string;
  onRetry?: () => void;
};

export const ProPilotSystemErrorBubble = ({ text, onRetry }: ProPilotSystemErrorBubbleProps) => {
  const { t } = useTranslation("translation");
  const canRetry = Boolean(onRetry);
  return (
    <Stack
      as="div"
      alignItems="center"
      gap="spacingMd"
      className={css.systemErrorBubble}
      qaId="ProPilotSystemErrorBubble"
      role="alert"
    >
      <Typography variant="labelSmallRegular" tag="span" className={css.reason}>
        {t("propilot.error.prefix", "Something went wrong: ")}
        <span data-qa-id="ProPilotSystemErrorBubble.reason">{text}</span>
      </Typography>
      <Button
        kind="secondary"
        small
        disabled={!canRetry}
        title={t("propilot.error.retry", "Retry")}
        qaId="ProPilotSystemErrorBubble.retry"
        onClick={onRetry}
      >
        {t("propilot.error.retry", "Retry")}
      </Button>
    </Stack>
  );
};
